import axios from '@/libs/api.request'

export const createCostEstimateSubmit = (partCostId, scope, name, note) => {
  return axios.request({
    url: `part-costs/${partCostId}/estimate/submission/create`,
    method: 'post',
    data: { scope: scope, name: name, note: note }
  })
}

export const getCostEstimateSubmits = (partCostId, name) => {
  return axios.request({
    url: `part-costs/${partCostId}/estimate/submission?name=${name}`,
    method: 'get'
  })
}

export const checkBomScrapIntegrity = (bomId, version) => {
  return axios.request({
    url: `/bom/check-bom-scrap-integrity/${bomId}/${version}`,
    method: 'get'
  })
}
